"use client";
import { ArrowUpRight } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

// Interface for transformed blog posts
interface TransformedBlogPost {
  id: string;
  title: string;
  category: string;
  date: string;
  readTime: string;
  author: {
    name: string;
    role: string;
    avatar: string;
    expertise: string[];
    bio: string;
  };
  excerpt: string;
  coverImage: string;
  slug: string;
}

export default function BlogPostCard({
  index,
  post,
}: {
  index: number;
  post: TransformedBlogPost;
}) {
  // Format date to show month abbreviation
  // const formatDate = (dateString: string) => {
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString("en-US", { month: "short" }).toUpperCase();
  // };

  return (
    <Link key={post.slug} href={`/blogs/${post.slug}`}>
      <div className="group cursor-pointer h-full bg-white rounded-sm  shadow-lg transition-all  flex flex-col">
        {/* Content Section */}
        <div className="flex flex-col  h-full">
          {/* Image Section */}
          <div className="relative rounded-xs aspect-[1800/900] block mb-6 overflow-hidden p-6">
            <Image
              src={post.coverImage}
              alt={post.title}
              fill
              className="object-cover"
            />
          </div>
          <div className="px-6 pb-6  flex flex-col justify-between flex-1">
            {/* Category Badge */}
            <div className="mb-3">
              <span className="inline-block bg-indigo-50 text-indigo-700 text-xs font-medium px-2 py-1 rounded">
                {post.category}
              </span>
            </div>

            {/* Title with External Link Icon */}
            <div className="block group mb-3">
              <div className="flex items-start justify-between gap-3">
                <h3 className="text-xl font-semibold text-gray-900 line-clamp-2 group-hover:text-indigo-600 transition-colors flex-1">
                  {post.title}
                </h3>
                <ArrowUpRight
                  size={20}
                  className="text-gray-400 group-hover:text-indigo-600 transition-colors flex-shrink-0 mt-1"
                />
              </div>
            </div>

            {/* Excerpt */}
            <p className="text-gray-600 text-sm line-clamp-2 mb-4 ">
              {post.excerpt}
            </p>

            {/* Author Section */}
            <div className="flex items-center space-x-3 mt-auto">
              <div className="relative h-10 w-10 rounded-full overflow-hidden">
                <Image
                  src={post.author.avatar}
                  alt={post.author.name}
                  fill
                  className="object-cover"
                />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">
                  {post.author.name}
                </p>
                <p className="text-xs text-gray-500">{post.date}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
